package com.cs.ejobin.data.supabase.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProfileUpdateRow(
    val name: String,
    val phone: String,
    @SerialName("is_available") val isAvailable: Boolean,
    val skills: List<String>,
    @SerialName("photo_url") val photoUrl: String? = null,
    val description: String? = ""
)